var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHofBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 75,
    viewBox: "0 0 65 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(-3731 -7548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15",
    "data-name": "Polygon 15",
    d: "M56.25,0,75,32.5,56.25,65H18.75L0,32.5,18.75,0Z",
    transform: "translate(3796 7548) rotate(90)",
    fill: "#ffd800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15_-_Outline",
    "data-name": "Polygon 15 - Outline",
    d: "M21.06,4,4.618,32.5,21.06,61H53.94L70.382,32.5,53.94,4H21.06M18.75,0h37.5L75,32.5,56.25,65H18.75L0,32.5Z",
    transform: "translate(3796 7548) rotate(90)",
    fill: "#bc9f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M23.825-18.606l8.981,1.325a2,2,0,0,1,1.606,1.35,2.008,2.008,0,0,1-.494,2.05L27.406-7.494l1.538,9.163a2,2,0,0,1-2.913,2.1L18.006-.513,9.988,3.769a2.014,2.014,0,0,1-2.113-.144,1.99,1.99,0,0,1-.8-1.956L8.613-7.494,2.1-13.881a2.009,2.009,0,0,1-.493-2.05,1.988,1.988,0,0,1,1.608-1.35l8.974-1.325,4.025-8.271A1.992,1.992,0,0,1,18.006-28a2,2,0,0,1,1.8,1.126Z",
    transform: "translate(3746 7596)",
    fill: "#bc9f00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHofBadge);
export default __webpack_public_path__ + "static/media/hof-badge.776ee265.svg";
export { ForwardRef as ReactComponent };